module.exports = __webpack_public_path__ + "static/media/clickFooter.585c2b96.wav";